<template lang="pug">
.banner
  .imgs(v-for="(value, key) in imgs",
        v-show="showPage === key"
        :key="key")
    img.img(
        :style="{transform: `scale(${scale})`}"
        :src="value.img")
  .mask
</template>
<script>
import TWEEN from '@tweenjs/tween.js'
const Banner = {
  props: ['imgs'],
  data () {
    return {
      scale: 1,
      showPage: 0,
      animate: null
    }
  },
  mounted () {
    this.turn()
  },
  components: {

  },
  computed: {

  },
  methods: {
    turn () {
      let _this = this
      this.animate = new TWEEN.Tween({
        scale: 1
      })
      .to({
        scale: 1.2
      }, 4000)
      .onUpdate(function () {
        _this.scale = this.scale
      })
      .onComplete(() => {
        _this.turn()
        this.showPage = ++this.showPage % this.imgs.length
      })
      .start()
    },
    next () {
      this.showPage = (++this.showPage + this.imgs.length) % this.imgs.length
      this.animate.stop()
      this.turn()
    },
    prev () {
      this.showPage = (--this.showPage + this.imgs.length) % this.imgs.length
      this.animate.stop()
      this.turn()
    }
  }
}
export default Banner
</script>

<style scoped lang="stylus">
@media (max-width: 720px) {
  .banner{
    height: 100%;
    width: 100%;
    .imgs{
      position: relative;
      height: 100%;
      .img{
        position: absolute;
        left: -50%;
        display: block;
        height: 100%;
      }
    }
    .mask{
      background-color: rgba(0,43,105,.5);
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
    }
  }
}
@media (min-width: 720px) {
  .banner{
    height: 100%;
    width: 100%;
    .imgs{
      width: 100%;
      height: 100%;
      .img{
        display: block;
        width: 100%;
        height: 100%;
      }
    }
    .mask{
      background-color: rgba(0,43,105,.5);
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// banner.vue?8298f13a